import { sendEvent } from 'configs/firebase'

export type TagSelectorDoctorTrackPayload = {
  tagId: string
  scheduleId: string
}

const tagSelectorAnalytics = {
  trackDoctorTagAdd(payload: TagSelectorDoctorTrackPayload): void {
    sendEvent('medical_record_tag_doctor_add', payload)
  },

  trackDoctorTagRemove(payload: TagSelectorDoctorTrackPayload): void {
    sendEvent('medical_record_tag_doctor_remove', payload)
  },
}

export default tagSelectorAnalytics
